import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { Skeleton } from '@mui/material';
import DeviceManager from '@/components/util/deviceManager';

export const SkeletonPathCategory = () => {
  return (
    <Grid item xs={4} lg="auto" display="flex" justifyContent="center" alignItems="center">
      <Stack
        width={{ xs: '114px', lg: '154px' }}
        height={{ xs: '114px', lg: '154px' }}
        gap={2}
        alignItems="center"
        justifyContent="center"
        p={{ xs: '10px', lg: '14px' }}
        overflow="hidden"
        sx={{
          borderRadius: '8px',
          border: '1px solid #D0D5DD',
          background: '#FFF',
        }}
      >
        <Stack width="38px" height="38px" sx={{ background: 'white', borderRadius: '8px' }}>
          <Skeleton variant="rounded" height={38} width={38} />
        </Stack>
        <Skeleton
          variant="text"
          width={98}
          sx={{ fontSize: DeviceManager.isMobile() ? '13px' : '16px' }}
        />
        <Skeleton variant="text" width={64} />
      </Stack>
    </Grid>
  );
};
